import  { useEffect, useState } from 'react';
import tokenImg from '../../assets/images/tokenImg183.png';
import AirDropSuccessModal from '../modals/airdrop-success';
import { useGetAirDropTimer } from '../home/api/api';
import { useAirDropActivate, useGetAirdropAmount } from './api/airDropApi';
import Loader from '../Loader/buttonLoad';
import Web3 from 'web3';
import { contractAddress } from '../../contract/contractAddress';
import usdtAbi from '../../contract/usdtAbi.json';
import pillMlmAbi from '../../contract/pillMlmAbi.json';
import { useToast } from '../../hook/usetoast';
import { useModalContext } from '../../contexts/ModalContext';
import { generateSecureRandomNumber } from '../../hook/randomString';
import { useAppKitAccount } from '@reown/appkit-controllers/react';
import { useAccount } from 'wagmi';
const AirdropDeposit = () => {
    const { isloadingconnect, setIsloadingconnect, setBalance, userDetails, setApiRes, setCheck
    } = useModalContext()
    const getyear = new Date().getFullYear();
    const [airdropSuccessModal, setAirdropSuccessModal] = useState(false);
    const { isLoading: timeLoading } = useGetAirDropTimer()

    const { data: airDropAmount } = useGetAirdropAmount()

    const { connector } = useAccount();


    const airDropActivate = useAirDropActivate()
    const [timeLeft, setTimeLeft] = useState(0);
    const [status, setStatus] = useState(false)

    const [amount, setAmount] = useState();
    const { address } = useAppKitAccount()
    const toast = useToast();

    useEffect(() => {
        const futureTime = new Date(userDetails?.data?.dateforbefore);

        if (isNaN(futureTime)) {
            return;
        }

        const countdown = setInterval(() => {
            const now = new Date();
            const timeDifference = futureTime - now;

            if (timeDifference <= 0) {
                clearInterval(countdown);
            } else {
                setTimeLeft(timeDifference);
            }
        }, 1000);

        return () => clearInterval(countdown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userDetails]);


    useEffect(() => {
        if (!connector || !address) return;

        const load = async () => {
            const provider = await connector.getProvider?.();
            if (!provider) return;

            await Promise.all([activateAmount(provider), CheckUserStatus(provider)]);
        };

        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connector, address]); // no status here



    const activateAmount = async (provider) => {
        try {
            setIsloadingconnect(true);

            const web3 = new Web3(provider);
            const userRegister = new web3.eth.Contract(pillMlmAbi, contractAddress?.pillMLM);
            const usdtActiveAmount = await userRegister.methods.activationFee().call();

            const valueInWei = web3.utils.fromWei(usdtActiveAmount, "ether");
            setAmount(valueInWei);
        } catch (error) {
            setIsloadingconnect(false)
        } finally {
            setIsloadingconnect(false);
        }
    };
    const formatTime = (timeInMillis) => {
        const hours = Math.floor(timeInMillis / 1000 / 60 / 60);
        const minutes = Math.floor((timeInMillis / 1000 / 60) % 60);
        const seconds = Math.floor((timeInMillis / 1000) % 60);
        return {
            hours: hours.toString().padStart(2, '0'),
            minutes: minutes.toString().padStart(2, '0'),
            seconds: seconds.toString().padStart(2, '0')
        };
    };
    const { hours, minutes, seconds } = formatTime(timeLeft);
    const isButtonDisabled = timeLeft <= 0;





    const [randomData, setRandomData] = useState(Math.floor(100000 + generateSecureRandomNumber() * 900000))

    const userActivate = async () => {
        setIsloadingconnect(true)
        const provider = await connector?.getProvider?.();

        if (!provider) {
            toast.error('Web3 provider not found');
            return;
        }

        const web3 = new Web3(provider);
        const userRegister = new web3.eth.Contract(pillMlmAbi, contractAddress?.pillMLM);
        const usdtActiveAmount = await userRegister.methods.activationFee().call();

        const valueInWei = web3.utils.fromWei(usdtActiveAmount, 'ether');

        const usdtContract = new web3.eth.Contract(usdtAbi, contractAddress?.USDT);
        const usdtUserBalance = await usdtContract.methods.balanceOf(address).call();
        const usdtUserBalanceInUnits = web3.utils.fromWei(usdtUserBalance, 'ether');

        setBalance(usdtUserBalanceInUnits)
        if (Number(usdtUserBalanceInUnits) < Number(valueInWei)) {
            toast.error("Insufficient USDT Balance")
            setIsloadingconnect(false)
            return
        }

        try {
            const userRegister = new web3.eth.Contract(pillMlmAbi, contractAddress?.pillMLM);

            const usdtContract = new web3.eth.Contract(usdtAbi, contractAddress?.USDT);
            const usdtAllowance = await usdtContract.methods.allowance(address, contractAddress?.pillMLM).call();
            const usdtActiveAmount = await userRegister.methods.activationFee().call();

            if (usdtActiveAmount > usdtAllowance) {
                const usdtApprove = await usdtContract.methods.approve(contractAddress?.pillMLM, usdtActiveAmount).send({ from: address });

                if (usdtApprove?.transactionHash) {
                    await userActive();
                }
                return;
            }
            await userActive();


        } catch (error) {
            setIsloadingconnect(false)

            const errorMessage = error?.message || "";

            if (
                errorMessage.includes('User denied transaction') ||
                errorMessage.includes('User rejected the request') ||
                errorMessage.includes('User denied transaction signature') ||
                errorMessage.includes('cancelled') ||
                errorMessage.includes('Rejected') ||
                errorMessage.includes('Transaction declined')
            ) {
                toast.error('Transaction cancelled by user');
            } else {
                toast.error(`User rejected the request ${errorMessage}`);
            }
        } finally {
            setIsloadingconnect(false)
        }
    };


    
    
   

    const userActive = async () => {
        setIsloadingconnect(true)
        try {
            const provider = await connector?.getProvider?.();
            const web3 = new Web3(provider);
            const userRegister = new web3.eth.Contract(pillMlmAbi, contractAddress?.pillMLM);


            if (userDetails?.data?.refferdByAddress !== '0xd32ef3583cf4a6c0d675d88e847149824f2cbe92') {

                const estimateGas = await userRegister.methods.registerFor(address, userDetails?.data?.refferdByAddress).estimateGas({ from: address });

                const feeData = await web3.eth.calculateFeeData();


                const referralUser = await userRegister.methods.registerFor(address, userDetails?.data?.refferdByAddress).send({
                    from: address,
                    gas: estimateGas,
                    maxFeePerGas: feeData.maxFeePerGas,
                    maxPriorityFeePerGas: feeData.maxPriorityFeePerGas
                });
                if (referralUser?.transactionHash) {
                    const res = await airDropActivate.mutateAsync({ address: address, amount: 2, hash: referralUser?.transactionHash, randomID: randomData })
                    if (res?.status) {
                        setApiRes(res)
                        setAirdropSuccessModal(!airdropSuccessModal)
                        setRandomData(Math.floor(100000 + generateSecureRandomNumber() * 900000))
                        setCheck(res)


                    }
                }
            } else {


                const estimateGas = await userRegister.methods.registerIn(contractAddress?.Owner).estimateGas({ from: address });

                const feeData = await web3.eth.calculateFeeData();
                const userAirdrop = await userRegister.methods.registerIn(contractAddress?.Owner).send({
                    from: address,
                    gas: estimateGas,
                    maxFeePerGas: feeData.maxFeePerGas,
                    maxPriorityFeePerGas: feeData.maxPriorityFeePerGas
                });
                if (userAirdrop?.transactionHash) {
                    const res = await airDropActivate.mutateAsync({ address: address, amount: 2, hash: userAirdrop?.transactionHash, randomID: randomData })
                    if (res?.status) {
                        setApiRes(res)
                        setAirdropSuccessModal(!airdropSuccessModal)
                        setRandomData(Math.floor(100000 + generateSecureRandomNumber() * 900000))
                        setCheck(res)


                    }
                }
            }

        } catch (error) {

            const errorMessage = error?.message || "";

            if (
                errorMessage.includes('User denied transaction') ||
                errorMessage.includes('User rejected the request') ||
                errorMessage.includes('User denied transaction signature') ||
                errorMessage.includes('cancelled') ||
                errorMessage.includes('Rejected') ||
                errorMessage.includes('Transaction declined')
            ) {
                toast.error('Transaction cancelled by user');
            } else {
                toast.error(`Error: ${errorMessage}`);
            }
            setIsloadingconnect(false)
        } finally {
            setIsloadingconnect(false)
        }
    };

    


    const CheckUserStatus = async (provider) => {
        try {
            setIsloadingconnect(true);

            const web3 = new Web3(provider);
            const userRegister = new web3.eth.Contract(pillMlmAbi, contractAddress?.pillMLM);

            const userAirdrop = await userRegister.methods.registerInfo(address).call();

            setStatus(userAirdrop?.active ?? false);
        } catch (error) {
            setIsloadingconnect(false)
        } finally {
            setIsloadingconnect(false);
        }
    };


    return (
        <>
            {(timeLoading || isloadingconnect) && <Loader />}
            <div className="mainContent mainVH-100">
                <div className="homebanner depositBanner">
                    <div className="container position-relative h-100">
                        <div className='row justify-content-center align-items-center h-100'>
                            <div className="col-lg-9">
                                <div className="bannerContent">
                                    <h2 >Invest {amount} USDT </h2>
                                    <h1 className='depositTitle'>To Initiate the <img src={require('../../assets/images/coin45.png')} alt='coinImg' /> {airDropAmount?.data[0]?.reward} Airdrop</h1>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-8">
                                            <p>It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                                        </div>
                                    </div>
                                    {
                                        !timeLoading && !status ? (
                                            <>
                                                {!isButtonDisabled && (
                                                    <div className='mb-4'>
                                                        <div className='timeCountdown'>
                                                            <span>
                                                                <span className="nexaFont">{hours.toString().padStart(2, "0")}</span> <span className='smTxt'>Hours</span>
                                                            </span>
                                                            <span className='v-line'></span>
                                                            <span>
                                                                <span className="nexaFont">{minutes.toString().padStart(2, "0")}</span> <span className='smTxt'>Mins</span>
                                                            </span>
                                                            <span className='v-line'></span>
                                                            <span>
                                                                <span className="nexaFont">{seconds.toString().padStart(2, "0")}</span> <span className='smTxt'>Sec</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className='text-center position-relative'>
                                                    <button className='btn btn-primary fs-18 fw-600 px-4 h-auto px-lg-5 def-py-14' onClick={userActivate} >Deposit Now</button>
                                                </div>
                                            </>
                                        ) :
                                            <>

                                            </>
                                    }

                                </div>
                            </div>
                        </div>
                        <div className="tokenimgPos">
                            <div className='leftImg animate__animated animate__pulse animate__infinite'><img src={tokenImg} alt='tokenImg183' className='img183rotate31' /></div>
                            <div className='rightImg animate__animated animate__pulse animate__infinite'><img src={tokenImg} alt='tokenImg138' className='img138rotate31' /></div>
                        </div>
                    </div>
                </div>
                <div className='footerbottom mt-n5'>
                    Copyright © {getyear} the pill  – All Rights Reserved.
                </div>
            </div>
            <AirDropSuccessModal modalOpen={airdropSuccessModal} modalClose={() => setAirdropSuccessModal(!airdropSuccessModal)} reward={airDropAmount?.data[0]?.reward} rewardStatus={isButtonDisabled} />
        </>
    )
}

export default AirdropDeposit